import { IMDSCalendarGridHeaderProps } from "./calendar-grid-header.types";
import { StyledCalendarGridHeader } from "./calendar-grid-header.style";

export function MDSCalendarGridHeader(props: IMDSCalendarGridHeaderProps) {
  return <StyledCalendarGridHeader {...props} />;
}
